"use client";

import React from "react";
import { Trophy } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
const players = [{
  id: 1,
  name: "Alex Mercer",
  photo: "https://enormous-cat-1.10web.cloud/wp-content/uploads/2026/03/IMG_1353.jpg?v=8nsyfdtjmji",
  commitment: "NCAA Div I - Boston College",
  team: "U18 AAA Elite",
  position: "Forward"
}, {
  id: 2,
  name: "Jordan Hayes",
  photo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/7F701915-E420-4F1E-9CEE-E55B8209E608.jpg?v=jznyxn9fwcc",
  commitment: "USPORTS - Univ. of Ottawa",
  team: "Prep School Varsity",
  position: "Defense"
}, {
  id: 3,
  name: "Marcus Thorne",
  photo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/IMG_0236-copy.jpeg?v=fg746die89b",
  commitment: "NCAA DIV I",
  team: "Junior A",
  position: "Goalie"
}, {
  id: 4,
  name: "Elias Vance",
  photo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/IMG_1206.jpg?v=sxn4kb4dy49",
  commitment: "WHL - Portland Winterhawks",
  team: "U16 AAA National",
  position: "Forward"
}, {
  id: 5,
  name: "Carter Finn",
  photo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/IMG_0861.jpeg?v=u409uce0qo",
  commitment: "BCHL - Penticton Vees",
  team: "U18 AAA Elite",
  position: "Defense"
}, {
  id: 6,
  name: "Julian Rossi",
  photo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/IMG_1132.jpeg?v=10brq8i4p0yp",
  commitment: "NCAA Div I - Michigan",
  team: "USHL",
  position: "Forward"
}];
export default function AdvancementSuccessStories() {
  return <section data-section-id="69697" id="advancement-success-stories" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/4 w-[40rem] h-[40rem] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[30rem] h-[30rem] bg-accent/10 rounded-full blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="mb-16 md:mb-24 flex flex-col md:flex-row md:items-end justify-between gap-8 border-b border-border/30 pb-8">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-6xl font-sans font-bold tracking-tighter uppercase mb-4 text-foreground leading-none">
              Advancement <br />
              <span className="text-primary italic">Success Stories</span>
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl max-w-xl font-sans">
              Proven results. See where our dedicated mentorship and extensive
              scouting network have taken these elite athletes.
            </p>
          </div>
          <div className="hidden md:block text-right">
            <p className="text-xs font-mono text-primary uppercase tracking-[0.2em]">
              DB Hockey Advancement
            </p>
            <p className="text-[10px] text-muted-foreground/80 mt-1 uppercase font-mono tracking-widest">
              Elite Athleticism Meets Cold Precision
            </p>
          </div>
        </div>

        <div className="relative group/carousel">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6">
              {players.map((player, i) => <CarouselItem key={player.id} data-index={i} className="pl-4 md:pl-6 sm:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                  {}
                  <div className="relative h-[500px] group/card overflow-hidden border border-border bg-card/40 backdrop-blur-sm rounded-sm transition-all duration-300 hover:border-primary hover:shadow-[0_0_40px_rgba(218,11,11,0.2)]">
                    {}
                    <img src={player.photo} alt={`${player.name} - ${player.commitment}`} className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover/card:scale-105 saturate-[0.8] brightness-[0.9]" />

                    {}
                    <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent opacity-90 transition-opacity duration-500 group-hover/card:opacity-100" />
                    
                    {}
                    <div className="absolute inset-x-0 bottom-0 h-1/2 backdrop-blur-[1px] opacity-50" />

                    {}
                    <div className="absolute inset-0 p-6 flex flex-col justify-end z-10">
                      <div className="transform translate-y-2 transition-transform duration-300 ease-out group-hover/card:translate-y-0">
                        <Badge variant="default" className="mb-4 bg-primary text-primary-foreground border-none uppercase tracking-[0.15em] font-mono text-[10px] py-1 px-3 rounded-sm shadow-[0_0_20px_rgba(218,11,11,0.4)]">
                          <Trophy className="w-3 h-3 mr-1.5" /> Committed
                        </Badge>
                        
                        <h3 className="text-3xl font-sans font-bold uppercase tracking-tighter text-foreground mb-1 leading-none">
                          {player.name}
                        </h3>
                        
                        <p className="text-primary font-mono text-xs md:text-sm mb-4 uppercase tracking-wide">
                          {player.commitment}
                        </p>

                        {}
                        <div className="flex items-center justify-between pt-4 border-t border-border/20 opacity-0 transform translate-y-2 transition-all duration-300 delay-75 group-hover/card:opacity-100 group-hover/card:translate-y-0">
                          <div className="flex flex-col">
                            <span className="text-[9px] uppercase tracking-widest text-muted-foreground font-mono mb-1">
                              Position
                            </span>
                            <span className="text-xs text-foreground font-bold font-sans uppercase">
                              {player.position}
                            </span>
                          </div>
                          <div className="flex flex-col text-right">
                            <span className="text-[9px] uppercase tracking-widest text-muted-foreground font-mono mb-1">
                              Previous Team
                            </span>
                            <span className="text-xs text-foreground font-bold font-sans uppercase">
                              {player.team}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {}
                    <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-primary/0 transition-colors duration-300 group-hover/card:border-primary m-4" />
                    <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-primary/0 transition-colors duration-300 group-hover/card:border-primary m-4" />
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            {}
            <div className="absolute top-1/2 -translate-y-1/2 -left-4 md:-left-12 z-20 opacity-0 transition-opacity duration-300 group-hover/carousel:opacity-100">
              <CarouselPrevious className="relative left-0 right-auto h-12 w-12 rounded-sm bg-background/90 backdrop-blur-md border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all shadow-xl" />
            </div>
            <div className="absolute top-1/2 -translate-y-1/2 -right-4 md:-right-12 z-20 opacity-0 transition-opacity duration-300 group-hover/carousel:opacity-100">
              <CarouselNext className="relative left-auto right-0 h-12 w-12 rounded-sm bg-background/90 backdrop-blur-md border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all shadow-xl" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}